import { render, staticRenderFns } from "./DepositRevisionListItem.vue?vue&type=template&id=47c24dd2&scoped=true&lang=pug&"
import script from "./DepositRevisionListItem.vue?vue&type=script&lang=js&"
export * from "./DepositRevisionListItem.vue?vue&type=script&lang=js&"
import style0 from "./DepositRevisionListItem.vue?vue&type=style&index=0&id=47c24dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c24dd2",
  null
  
)

export default component.exports